import React from "react";
import { DraggableProvided } from "react-beautiful-dnd";

import { StackProps } from "@mui/material";
import { DealStage, DealStageItem, UpdateDealStageData } from "store/types";
import { INotePopup } from "..";
import { SharedDealCard } from "../Pipeline-card/SharedDealCard";
import { Column } from "./Column";

interface Props extends StackProps {
  stage: DealStage;
  updateColumn: (data: UpdateDealStageData) => void;
}

export const SharedDealsColumn: React.FC<Props> = ({ stage, updateColumn }) => {
  const renderCard = (item: DealStageItem, draggableProvided: DraggableProvided | undefined, isDragging: boolean, stageId: number, setNotePopup?: (data: INotePopup) => void) => {
    void isDragging;
    void stageId;
    void setNotePopup;
    if (!draggableProvided) return null;
    return (
      <div
        ref={draggableProvided.innerRef}
        {...draggableProvided.draggableProps}
        {...draggableProvided.dragHandleProps}
        style={{
          ...draggableProvided.draggableProps.style,
          userSelect: "none",
          WebkitUserSelect: "none",
          msUserSelect: "none",
          MozUserSelect: "none"
        }}
      >
        <SharedDealCard {...item} />
      </div>
    );
  };

  return (
    <Column
      stage={stage}
      headerColor="#B96006"
      showControls={false}
      showStatusMenu={false}
      updateColumn={updateColumn}
      renderCard={renderCard}
    />
  );
};
